import React from 'react'
import LeaveCountLayout from './LeaveCountLayout'
import LeaveListLayout from './LeaveListLayout'

const LeaveLayout = () => {
    return (
        <div className="min-h-screen flex flex-col items-center bg-gray-100 p-4">
            <LeaveCountLayout vacationCount={5} sickCount={2} />
            <LeaveListLayout />
        </div>
    )
}

export default LeaveLayout
